export enum FETCH_STATUS {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  FULFILLED = 'FULFILLED',
  NULL = 'NULL',
}
